var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FDAD13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0188 24.8233C26.5351 25.8798 25.8238 26.8449 24.9214 27.6614C24.0189 28.4779 22.9435 29.1291 21.755 29.5746C20.5664 30.02 19.2902 30.25 18 30.25C16.7098 30.25 15.4336 30.02 14.245 29.5746C13.0565 29.1291 11.9811 28.4779 11.0786 27.6614C10.1762 26.8449 9.46489 25.8798 8.9812 24.8233C8.64678 24.0928 8.42525 23.3277 8.32037 22.5489C8.37087 22.5674 8.42449 22.5871 8.48156 22.6081C8.60651 22.6541 8.74803 22.7061 8.90957 22.7644C9.43774 22.955 10.1115 23.185 10.9467 23.4061C12.6195 23.8488 14.9176 24.25 18 24.25C21.2463 24.25 23.6229 23.8332 25.3165 23.3757C26.1625 23.1472 26.832 22.9101 27.346 22.7148C27.4682 22.6684 27.577 22.6263 27.6742 22.5883C27.5672 23.3535 27.3476 24.1052 27.0188 24.8233Z",
    fill: "white",
    stroke: "#362221",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.9397C20 13.5288 21.4954 12.1148 22.8813 11.8501C23.0891 11.8105 23.2948 11.7839 23.5 11.7842C23.7041 11.7845 23.9077 11.81 24.1123 11.8481C25.5011 12.1064 27 13.5333 27 14.9459C27 14.9642 27 14.9822 27 14.9998C27 15.9998 26 14.4998 23.5 14.3998C21 14.2998 20 15.9998 20 14.9998C20 14.9802 20 14.9601 20 14.9397Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.9397C9 13.5288 10.4954 12.1148 11.8813 11.8501C12.0891 11.8105 12.2948 11.7839 12.5 11.7842C12.7041 11.7845 12.9077 11.81 13.1123 11.8481C14.5011 12.1064 16 13.5333 16 14.9459C16 14.9642 16 14.9822 16 14.9998C16 15.9998 15 14.4998 12.5 14.3998C10 14.2998 9 15.9998 9 14.9998C9 14.9802 9 14.9601 9 14.9397Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13640_23513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 18) rotate(90) scale(18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAD13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.3084d57c.svg";
export { ForwardRef as ReactComponent };